import _ from 'lodash';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import {
  AttributeType,
  REGEXP_DECIMAL,
  REGEXP_INTEGER,
  REGEXP_PERCENTAGE,
} from '../../../../../../../../services/common/Constants';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const SetValue = ({fieldName, showLabel, availableValueOptions, selectedFieldSubType, readOnly = false}) => {
  const { setError, clearErrors } = useFormContext();
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const validate = (value) => {
    if (!value) {
      clearErrors(fieldName);
      return true;
    }

    let isValid = true;
    let errorMessage = '';

    switch (selectedFieldSubType) {
      case AttributeType.INTEGER:
        if (!REGEXP_INTEGER.test(value)) {
          errorMessage = i18next.t('attributes.errors.integer');
        }
        break;
      case AttributeType.DECIMAL:
        if (!REGEXP_DECIMAL.test(value)) {
          errorMessage = i18next.t('attributes.errors.decimal');
        }
        break;
      case AttributeType.PERCENTAGE:
        if (!REGEXP_PERCENTAGE.test(value)) {
          errorMessage = i18next.t('attributes.errors.percentage');
        }
        break;
      default:
        break;
    }

    if (errorMessage) {
      setError(fieldName, {
        type: 'manual',
        message: errorMessage,
      });
      isValid = false;
    } else {
      clearErrors(fieldName);
    }

    return isValid;
  };

  const commonProps = {
    fieldName: availableValueOptions?.length ? `${fieldName}.0` : fieldName,
    label,
    placeholder,
    uxVariant: 'criteriaInput',
    isRequired: true,
    validate,
    variant: 'standard',
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      labelVariant="chip"
      disabled={readOnly}
      triggerOnContinue
    />
  ) : (
    <CalculatorMultipleValueInput
      {...commonProps}
      triggerOnContinue
      disabled={readOnly}
    />
  )
}

export default SetValue;